import { render, staticRenderFns } from "./EmployeeEdit.vue?vue&type=template&id=7988a1da"
import script from "./EmployeeEdit.vue?vue&type=script&lang=ts"
export * from "./EmployeeEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports